import { Language } from "@/Common/Models/Domain/Language";
import type { ResolvedTranslations, Translations } from "../Model/Domain";

import en from "./en.json";
import es from "./es.json";
import it from "./it.json";
import pt from "./pt.json";

export const baseTranslations: Record<Language, ResolvedTranslations> = {
  [Language.ENGLISH]: en,
  [Language.SPANISH]: es,
  [Language.ITALIAN]: it,
  [Language.PORTUGUESE]: pt,
};

export function mergeBaseTranslations(
  locale: Language,
  remoteTranslations: Translations
): ResolvedTranslations {
  const translations = { ...baseTranslations[locale] };

  Object.entries(remoteTranslations).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      translations[key] = value;
    }
  });

  return translations;
}
